import { render, staticRenderFns } from "./ConsumedChart.vue?vue&type=template&id=a2e3bdfa&"
import script from "./ConsumedChart.vue?vue&type=script&lang=ts&"
export * from "./ConsumedChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports